import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Each player's entry renders its own events list + template (scoped by
  // data-entry-index), so the clicked button's container is looked up
  // directly rather than via Stimulus targets, which would be ambiguous
  // across the many repeated entry blocks in one form.
  addEvent(event) {
    const eventType = event.params.eventType
    const container = event.target.closest('[data-entry-index]')
    if (!container) return

    const list = container.querySelector('[data-match-result-target="eventsList"]')
    const template = container.querySelector('[data-match-result-target="eventTemplate"]')
    const index = list.children.length

    const html = template.innerHTML.replace(/__INDEX__/g, index)
    const wrapper = document.createElement('div')
    wrapper.innerHTML = html.trim()
    const row = wrapper.firstElementChild
    row.querySelector('[data-role="event-type"]').value = eventType
    list.appendChild(row)
  }

  removeEvent(event) {
    const row = event.target.closest('[data-event-index]')
    if (!row) return

    const idInput = row.querySelector('input[name$="[id]"]')
    if (idInput && idInput.value) {
      row.querySelector('input[name$="[_destroy]"]').value = '1'
      row.style.display = 'none'
    } else {
      row.remove()
    }
  }
}
